import { Link } from "react-router-dom";

export interface CrumbItem {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: CrumbItem[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm text-foreground-500 flex items-center gap-1 flex-wrap">
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-1">
            {item.to && !last ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors whitespace-nowrap">
                {item.label}
              </Link>
            ) : (
              <span className={last ? "text-foreground-800 font-medium" : ""} aria-current={last ? "page" : undefined}>
                {item.label}
              </span>
            )}
            {!last && <i className="ri-arrow-right-s-line text-foreground-300"></i>}
          </span>
        );
      })}
    </nav>
  );
}